export const ApiCode = Object.freeze({
  SUCCESS: 1,
  JWT_TOKEN_EXPIRED: 8,
})

export default { ApiCode }
